"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Box = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Spacing_1 = require("../Spacing");
/**
 * @deprecated Please replace with `div` plus Tailwind.
 */
var Box = function (_a) {
    var children = _a.children, _b = _a.rtl, rtl = _b === void 0 ? false : _b, m = _a.m, mt = _a.mt, mr = _a.mr, mb = _a.mb, ml = _a.ml, mx = _a.mx, my = _a.my, p = _a.p, pt = _a.pt, pr = _a.pr, pb = _a.pb, pl = _a.pl, px = _a.px, py = _a.py, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["children", "rtl", "m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "classNameOverride"]);
    var classes = __spreadArray(__spreadArray([], (0, Spacing_1.paddingClasses)({ p: p, pt: pt, pr: pr, pb: pb, pl: pl, px: px, py: py, rtl: rtl }), true), (0, Spacing_1.marginClasses)({ m: m, mt: mt, mr: mr, mb: mb, ml: ml, mx: mx, my: my, rtl: rtl }), true);
    return (react_1["default"].createElement("div", __assign({ className: (0, classnames_1["default"])(classes, classNameOverride) }, restProps), children));
};
exports.Box = Box;
exports.Box.displayName = "Box";
//# sourceMappingURL=Box.js.map